
import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { PhoneService } from '../../services/phone/phone.service';
import { ISipAccount } from '@jsphonelib';
import { MessageService } from '@wephone-utils';

@Component({
  selector: 'jsphone-status',
  templateUrl: 'jsphone-status.html',
  styleUrls: ['./jsphone-status.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JSPhoneStatus {
  public sipConnectionOK = true;

  constructor(
    private phoneService: PhoneService,
    private messageService: MessageService,
    private cdRef: ChangeDetectorRef
  ) {
    this.sipConnectionOK = !(this.phoneService.phoneConfig &&
      this.phoneService.phoneConfig.sipstack_enabled && !this.phoneService.isRegistered());

    this.messageService.subscribe('sipaccount:state',
      () => {
        this.sipConnectionOK = !(this.phoneService.phoneConfig &&
          this.phoneService.phoneConfig.sipstack_enabled && !this.phoneService.isRegistered());
        this.cdRef.markForCheck();
        this.cdRef.detectChanges();
      }
    );
  }

  phoneErrorMessage(): string {
    return this.phoneService.getRegisterErrorMessage();
  }

  get microphoneStateOK(): boolean {
    return this.phoneService.audioDevicesOK();
  }

  get chromeNotificationOK(): boolean {
    return this.phoneService.chromeNotificationOK();
  }
}
